import { render, staticRenderFns } from "./PermissionValidatorContainer.vue?vue&type=template&id=35715bfe&"
import script from "./PermissionValidatorContainer.vue?vue&type=script&lang=js&"
export * from "./PermissionValidatorContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports